import { CoreView } from '@/components/Theme/Core/CoreView';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const Row = withStyles(CoreView, {noSwitch: true, style: {
    flexDirection: 'row', 
    display: 'flex'
}});